import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { Event, Exhibitor, Post, Product } from '@planone/bau365/util-fair-data';

import { WatchlistActionTrigger, WatchlistItem, WatchlistItemIdentity, WatchlistPageContext } from './watchlist.models';

export const initWatchlist = createAction('[Watchlist Module] Init');

export const loadWatchlistSuccess = createAction(
  '[Watchlist/API] Load Watchlist Success',
  props<{ items: WatchlistItem[] }>()
);

export const loadWatchlistFailure = createAction(
  '[Watchlist/API] Load Watchlist Failure',
  props<{ error: HttpErrorResponse }>()
);

export const addWatchlistItemRequested = createAction(
  '[Watchlist/ToggleItemButton] Add item requested',
  props<{
    watchlistItem: WatchlistItemIdentity;
    pageContext: WatchlistPageContext;
  }>()
);

export const addWatchlistItemSuccess = createAction(
  '[Watchlist/API] Add item Success',
  props<{
    watchlistItem: WatchlistItem;
    pageContext: WatchlistPageContext;
    trigger: WatchlistActionTrigger;
  }>()
);

export const addWatchlistItemFailure = createAction('[Watchlist/API] Add item Failure', props<WatchlistItemIdentity>());

export const removeWatchlistItemRequested = createAction(
  '[Watchlist/ToggleItemButton] Remove item requested',
  props<{
    watchlistItem: WatchlistItemIdentity;
    pageContext: WatchlistPageContext;
  }>()
);

export const removeWatchlistItemSuccess = createAction(
  '[Watchlist/API] Remove item Success',
  props<{
    watchlistItem: WatchlistItemIdentity;
    pageContext: WatchlistPageContext;
    trigger: WatchlistActionTrigger;
  }>()
);

export const removeWatchlistItemFailure = createAction(
  '[Watchlist/API] Remove item Failure',
  props<WatchlistItemIdentity>()
);

export const deleteWatchlistItemFromList = createAction(
  '[Watchlist/Page] Delete item from watchlist requested',
  props<{
    watchlistItem: WatchlistItemIdentity;
    pageContext: WatchlistPageContext;
  }>()
);

export const shareWatchlistItemFromList = createAction(
  '[Watchlist/Page] Share item from watchlist requested',
  props<{
    watchlistItem: WatchlistItemIdentity;
    pageContext: WatchlistPageContext;
  }>()
);

export const shareActionWatchlistItemFromList = createAction(
  '[Watchlist/Page] Share item action from watchlist requested',
  props<{
    network: string;
    watchlistItem: WatchlistItemIdentity;
    pageContext: WatchlistPageContext;
  }>()
);

export const loadWatchlistEntity = createAction(
  '[Watchlist/API] Load item entity',
  props<{
    watchlistItem: WatchlistItemIdentity;
    pageContext: WatchlistPageContext;
    trigger: WatchlistActionTrigger;
    network?: string;
  }>()
);

export const loadWatchlistEntitySuccess = createAction(
  '[Watchlist/API] Load item entity Success',
  props<{
    watchlistItem: WatchlistItemIdentity;
    pageContext: WatchlistPageContext;
    trigger: WatchlistActionTrigger;
    post?: Post;
    exhibitor?: Exhibitor;
    event?: Event;
    product?: Product;
    brand?: Exhibitor;
    network?: string;
  }>()
);

export const loadWatchlistEntityFailure = createAction(
  '[Watchlist/API] Load item entity Failure',
  props<{
    watchlistItem: WatchlistItemIdentity;
    pageContext: WatchlistPageContext;
    trigger: WatchlistActionTrigger;
    network?: string;
  }>()
);

export const generateWatchlistDocument = createAction('[Watchlist/API] Generate document');

export const generateWatchlistDocumentSuccess = createAction(
  '[Watchlist/API] Generate document Success',
  props<{ documentId: string }>()
);

export const generateWatchlistDocumentFailure = createAction('[Watchlist/API] Generate document Failure');
